(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("datepicker", [], factory);
	else if(typeof exports === 'object')
		exports["datepicker"] = factory();
	else
		root["datepicker"] = factory();
})(this, function() {
return 